export default __webpack_public_path__ + "static/uk-guide-75e995ba5596135ec015434104ebf085.jpg";